module.exports = __webpack_public_path__ + "static/media/default.dc268a73.svg";